/**
 * 
 */
import SizeChanger from 'components/atoms/SizeChanger/SizeChanger';
import { useAppState } from "context";
import "./CreativeSizeDisplay.scss";


const CreativeSizeDisplay = () => {
  const { activeCreativeView } = useAppState();
  const { width, height } = activeCreativeView;

  return (
    <div className="size-container">
      <SizeChanger/>
      <div className="creative-size">{`${width}x${height}`}</div>
    </div>
  );
};

export default CreativeSizeDisplay;
